import { actionCreator, asyncActionCreator } from '../../redux/helper';
import { IStore } from '../../types';
import { StoreActionType, IStoreAction } from '../../../server/stores';

enum StoreActionTypes {
  FETCH_STORES = 'STORE/FETCH_STORES',
  UPDATE_STORES = 'STORE/UPDATE_STORES',
  SET_STORES = 'STORE/SET_STORES',
  WATCH_STORES = 'STORE/WATCH_STORES',
}

export const fetchStores = asyncActionCreator<IStore[]>(StoreActionTypes.FETCH_STORES);

interface UpdateStoresSagaPayload<T extends StoreActionType = StoreActionType> {
  actionType: T;
  updatePayload: Parameters<IStoreAction[T]>[1];
}

export const updateStores = asyncActionCreator<undefined, UpdateStoresSagaPayload>(
  StoreActionTypes.UPDATE_STORES,
);

export const setStores = actionCreator<IStore[]>(StoreActionTypes.SET_STORES);
export const watchStores = actionCreator(StoreActionTypes.WATCH_STORES);
